import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const noticeApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/notices/`, {params: params})
  },
  detail (noticeId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/notices/${noticeId}/`, {params: params})
  }
}

export default noticeApi
